
        Component.define('page-products', (el, params) => {
            /**
 * O componente Each recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
const $slider = $el.find('.box-products-slider');

$el.find('.btn-ga-saiba-mais').on('click', function(e){
    const url = $(this).attr('href');
    $document.trigger('ga-saiba-mais:click', [url]);
});

let createSlider = false;

$window
    .on('resize', function () {
        if (wW < 981) {
            if (!createSlider) {
                $slider.slick({
                    infinite: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                    dots: true,
                });

                createSlider = true;
            }
        } else {
            if (createSlider) {
                $slider.slick('unslick');

                createSlider = false;
            }
        }
    });

        });